export default {
    title: "",
    unavailable: "该产品不再可用。"
}